import { takeEvery, takeLatest } from 'redux-saga/effects';
import { VEHICLES_REGISTRY_MODULE } from '../../../configs/moduleNames';
import {
  LOAD_VEHICLE_REGISTRY_BY_ID,
  LOAD_VEHICLE_REGISTRY_LIST,
  LOAD_VEHICLE_REGISTRY_STATUS_HISTORY,
  LOAD_VEHICLE_TRIPS,
} from '../actions';
import loadVehicleRegistryList from './loadVehicleRegistryList';
import loadVehicleRegistryById from './loadVehicleRegistryById';
import loadVehicleRegistryStatusHistory from './loadVehicleRegistryStatusHistory';
import loadVehicleTrips from './loadVehicleTrips';

export default function* watchClient() {
  yield takeLatest(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_LIST, loadVehicleRegistryList);
  yield takeEvery(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_BY_ID, loadVehicleRegistryById);
  yield takeLatest(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_REGISTRY_STATUS_HISTORY, loadVehicleRegistryStatusHistory);
  yield takeLatest(VEHICLES_REGISTRY_MODULE + LOAD_VEHICLE_TRIPS, loadVehicleTrips);
}
